import React from 'react';
import ClickWordGame from './components/ClickWordGame';

function App() {
  return (
    <div className="App">
      <ClickWordGame />
    </div>
  );
}

export default App;